import { createFileRoute } from "@tanstack/react-router";
import PromptTemplatesListPage from "@/features/prompt-templates/pages/prompt-templates-list-page";

export const Route = createFileRoute("/_admin/prompt-engine/templates/")({
  component: PromptTemplatesListPage,
});
